import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../utils/headers.functions';

const API_URL = environment.API_URL;

export interface BusinessToolChild {
  key: string;
  title: string;
}

export interface BusinessToolRow {
  key: string;
  title: string;
  inPool: boolean;
  active: boolean;
  children: BusinessToolChild[];
}

export interface MyModulesResponse {
  planName: string | null;
  planId?: number | null;
  maxModules: number | null;
  modulesRemaining: number;
  availableModules: string[];
  enabledModules: string[];
  savedModules: string[];
  effectiveModules: string[];
  userConfigured: boolean;
  tools: BusinessToolRow[];
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class BusinessModulesService {
  constructor(private http: HttpClient) {}

  getMyModules(): Observable<MyModulesResponse> {
    const headers = getHeaders();
    return this.http.get<MyModulesResponse>(`${API_URL}/business/my-modules`, { headers });
  }

  updateMyModules(enabledModules: string[]): Observable<MyModulesResponse> {
    const headers = getHeaders();
    return this.http.put<MyModulesResponse>(
      `${API_URL}/business/my-modules`,
      { enabled_modules: enabledModules },
      { headers },
    );
  }
}
